import type { TrackEventRequest } from "@b2bportal/event-tracking-api";
import { merge } from "lodash-es";
import { trackCheckoutEvent } from "../sink";
import { getBaseTrackingProperties } from "./getBaseTrackingProperties";

export const trackBaseEvent = async (
  context: unknown,
  request: TrackEventRequest
) => {
  const baseTrackingProperties = getBaseTrackingProperties(context);

  try {
    await trackCheckoutEvent(
      merge({}, request, {
        properties: baseTrackingProperties,
      })
    );
    return;
  } catch {
    return;
  }
};
